import * as Yup from "yup";

export const facultySchema = Yup.object().shape({
  name: Yup.string().required("Facility name is required"),
  institution_id: Yup.string().required("Institution is required"),
});
